import { Dialog, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

const ResponsiveDialog = ({ mobileFullScreen = true, ...props }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return <Dialog {...props} fullScreen={mobileFullScreen && isMobile} />;
};

ResponsiveDialog.propTypes = {
  mobileFullScreen: PropTypes.bool,
};

export default ResponsiveDialog;
